module.exports = __webpack_public_path__ + "img/pro_06.bef860d2.jpg";